import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {CrmAddressBookContactRecordHdrContainerModel} from '../../../../../../models/aggregates/crm/address/crm-address-book-contact-record-hdr-container-model';

@Injectable({providedIn: 'root'})
export class CrmAddressBookContactRecordHdrService extends BaseApiTemplateService<CrmAddressBookContactRecordHdrContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'address-book-contact-record-hdrs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'address-book-contact-record-hdrs';
    this.httpClient = http;
  }

}
